/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// Filters
import './filters'

// Plugins
import './plugins'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// Translations
import i18n from './lang/i18n'
import swalHelper from '@/helpers/swal'

Vue.prototype.$storeInboundOrOutboundPopup = function () {
  swalHelper.success({
      title: i18n.t('time_conditions_save_success'),
      confirmButton: i18n.t('confirm')
    }, {
      timer: 1000
    }
  )
}
window.$storeInboundOrOutboundPopup = Vue.prototype.$storeInboundOrOutboundPopup

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  watch: {
    '$route' (to, from) {
      this.$store.dispatch('setCurrentRoute', to)
    }
  },
  render: h => h(App)
}).$mount('#app')
